export const ComparablesTypes = {
  COMPANY: 'company',
  MARKET: 'market',
  SECTOR: 'sector',
  BIGGEST_MOVERS: 'biggest-movers',
} as const
